import chengdu from './sichuan.json';
import { create3DmodelImg } from './create3DmodelImg';
class MaplibreGLMap {
  constructor(config) {
    this._map = null; // 地图实例
    this._mapReady = false; // 地图是否准备就绪
    this._container = config.container; // 地图容器
    this._LngLatBoundsLike = config.LngLatBoundsLike || null; // 地图边界
    this._center = config.center || [0, 0]; // 地图中心点
    this._style = config.style; // 地图样式
    this._zoom = Number(config.zoom) === 0 ? 0 : Number(config.zoom) || 2; // 地图初始缩放级别
    this._minZoom = Number(config.minZoom) || 0; // 地图最小缩放级别 0
    this._maxZoom = Number(config.maxZoom) === 0 ? 0 : Number(config.maxZoom) || 24; // 地图最大缩放级别 24
    this._pitch = Number(config.pitch) || 35; // 地图初始倾斜间距
    this._minPitch = Number(config.minPitch) || 0; // 地图最小倾斜间距0
    this._bearing = Number(config.bearing) || 0; // 地图默认旋转
    this._maxPitch = Number(config.maxPitch) === 0 ? 0 : Number(config.maxPitch) || 60; // 地图最大倾斜间距85,1.0的mapbox是60
    this._interactive = config.interactive || true; // 地图是否响应交互（鼠标，键盘，触摸的侦听），false不响应，true响应
    this._init();
  }
  _init() {
    const config = {
      container: this._container,
      center: this._center,
      style: this._style,
      zoom: this._zoom,
      minZoom: this._minZoom,
      maxZoom: this._maxZoom,
      pitch: this._pitch,
      minPitch: this._minPitch,
      maxPitch: this._maxPitch,
      bearing: this._bearing,
      interactive: this._interactive,
      maxBounds: [97.19503163999998, 25.636297445999983, 108.7545265133, 34.2809558],
      preserveDrawingBuffer: true, // 为true时，可用map.getCanvas().toDataURL()导出为png，为了性能优化默认为false
    };
    // maplibre渲染离线地图
    this._map = new maplibregl.Map(config);
  }
}

export { MaplibreGLMap };
